'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hamburger = void 0;
var $ = require("jquery");
var Hamburger = /** @class */ (function () {
    function Hamburger() {
        $('.trigHamburger').on('click', function () {
            var dataActive = $('.paramHamburger').attr('data-active');
            if (Number(dataActive) === 1) {
                $('.bulletHamburger ').attr('data-active', 0);
                $('.bulletNavi').attr('data-open', 0);
            }
            else {
                $('.bulletHamburger ').attr('data-active', 1);
                $('.bulletNavi').attr('data-open', 1);
            }
        });
        $('.triCloseNavi').on('click', function () {
            var dataActive = $('.paramHamburger').attr('data-active');
            if (Number(dataActive) === 1) {
                $('.bulletHamburger ').attr('data-active', 0);
                $('.bulletNavi').attr('data-open', 0);
            }
        });
        // bfcache
        window.addEventListener('pageshow', function (event) {
            if (event.persisted) {
                $('.bulletHamburger ').attr('data-active', 0);
                $('.bulletNavi ').attr('data-open', 0);
            }
        });
    }
    return Hamburger;
}());
exports.Hamburger = Hamburger;
exports.default = Hamburger;
